var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
// '#components' is imported by direct path: its barrel would close the hooks <-> components cycle (see CLAUDE.md).
import { useCallback } from 'react';
import { useModal } from '@lucidlink/uicore';
import { ServiceUnavailableModal } from '#components/modals/ServiceUnavailableModal';
import { MODAL_IDS } from '#constants';
// This hooks looks like a very simple wrapper, but it's extracted on purpose:
// It can be extended in the future to 'postpone' the error modal display in case of quick network flicks.
// This means that some additional logic here can be added to prevent showing the error modal with its recovery polling
// if only a transient Service Unavailable error is detected. Then the returned `handleServiceUnavailable` will just be used
// as a 'signal' and the internal logic of this hook will decide whether to show the modal immediately or wait for a few seconds before doing so.
export const useServiceUnavailableError = () => {
    _react_refresh_temp_1();
    const { closeModal, openModal } = useModal({
        modalId: MODAL_IDS.ServiceUnavailable,
        closeOnNavigate: false,
        closeOnUnmount: false,
    });
    const handleServiceUnavailable = useCallback(() => {
        openModal({
            content: _jsx(ServiceUnavailableModal, { closeModal: closeModal }),
        });
    }, [closeModal, openModal]);
    return { handleServiceUnavailable };
};
_react_refresh_temp_1(useServiceUnavailableError, "2oVHPp/BgfXmJLuuij4Z0qnu75M=", false, () => [useModal]);
